import { MentionedDomainMetrics } from "../types";

export function getVisibilityScoreColor(score: number) {
    if (score < 50) return '#f63842';
    if (score >= 50 && score < 80) return '#ffab00';
    if (score >= 75) return '#34bc6e';
}

export function getSovColor(sov: number, leaderSOV: number) {
    const score = (sov / leaderSOV) * 100;
    return getVisibilityScoreColor(score);
}

export function getSovClass(targetDomainSOVScore: number, topWebsites: MentionedDomainMetrics[]): string {
    if (topWebsites.length === 0) {
        return 'failed';
    }
    const highestSOVScore = topWebsites[0].share_of_voice;
    if (highestSOVScore === 0) {
        return 'failed';
    }
    const relativeSOVScore = (targetDomainSOVScore / highestSOVScore) * 100;
    if (relativeSOVScore >= 75) {
        return 'passed';
    }
    if (relativeSOVScore >= 50) {
        return 'warning';
    }
    return 'failed';
}
